exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".msg_item_com[data-v-3fa2bf00]{padding:10px 0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.msg_item_com .avatar_wrap[data-v-3fa2bf00]{margin-left:10px}\n", ""]);

// exports
